import React from 'react';
import {
  Form,
  Button,
  Typography,
  Row,
  Col,
  Select,
  DatePicker,
  Input
} from 'antd';
import {
  platformsList,
  launchTimeOptions,
  categoryListOptions,
  applicationStatusList,
  dateFormat,
  sortOrderList
} from '../constant';

const { Title, Text } = Typography;
const { Option } = Select;

const CommunitiesApplicationForm = ({
  form,
  resetForm,
  onFinish,
  totalCount,
  communityList
}) => {
  return (
    <Form form={form} onFinish={onFinish}>
      <Row justify="space-between">
        <Title level={4}>Filters</Title>
        <Text strong>Total Count: {totalCount}</Text>
      </Row>

      <Row gutter={16}>
        <Col span={4}>
          <Form.Item name="applicationSearch">
            <Input placeholder="Enter Search Text" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="sortOrder">
            <Select
              placeholder="Sort by time"
              showSearch={true}
              defaultValue={sortOrderList[0].value}>
              {sortOrderList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="status">
            <Select placeholder="Pending/Approved/Rejected/Unsubscribed">
              {applicationStatusList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="platform">
            <Select placeholder="platform?">
              {platformsList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="launchTime">
            <Select placeholder="Launch time?">
              {launchTimeOptions?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="category">
            <Select placeholder="category?">
              {categoryListOptions?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item name="startDate">
            <DatePicker
              showTime={true}
              showNow={false}
              format={dateFormat}
              style={{ width: '100%' }}
              placeholder="Select Start Date"
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="endDate">
            <DatePicker
              showTime={true}
              showNow={false}
              format={dateFormat}
              style={{ width: '100%' }}
              placeholder="Select End Date"
            />
          </Form.Item>
        </Col>
        <Col>
          <Button type="primary" htmlType="submit">
            Search
          </Button>
        </Col>
        <Col>
          <Button htmlType="button" onClick={resetForm}>
            Clear
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default CommunitiesApplicationForm;
